import { HttpMethods } from "../enums/HttpMethods";
import { HttpOptions } from "../data/HttpOptions";
import { HttpResponse } from "../types/HttpResponse";
import { useContext } from "react";
import { useAuth } from "../auth/useAuth";
import { NotificationTypes } from "../enums/NotificationTypes";
import { VspPortalActions } from "../store/VspPortalActions";
import VspPortalContext from "../store/VspPortalContext";

export const useVspPortalHttp = ( ): {

    fetchData( options: HttpOptions, query: string  ): Promise<HttpResponse>,
    getHttpOptions( method: HttpMethods, body: BodyInit | undefined  ): Promise<HttpOptions>

} => { 

    const { state, dispatch } = useContext( VspPortalContext );
    const { getIdToken } = useAuth( );
    
    
    const fetchData = async ( options: HttpOptions, query: string  ): Promise<HttpResponse> => {

        try {

            const response: Response = await fetch( query, options );

            if ( response.status === 200 ) {

                return {

                    response,
                    statusCode: response.status

                };


            } else {

                return {
            
                    response: null,
                    statusCode: response.status
            
                };

            }

        } catch {

            return {
            
                response: null,
                statusCode: null
        
            };

        }

    };

    const getFunctionKey = async( ): Promise< string | null > => {
    
    
        const authToken: string = await getIdToken( );
        const options = await getHttpOptionsWithoutFunctionKey ( authToken, HttpMethods.Get );
        const query = `${process.env.REACT_APP_API_URL}/functionKey`;

        const response = await fetchData( options, query  );
        
        if ( response.response === null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching security info' });

            return null;

        }

        const functionKey: string = await response.response?.text( );
        dispatch({ type: VspPortalActions.SetFunctionKey, payload: functionKey  });
        return functionKey;

    };
    
    const getHttpOptions = async( method: HttpMethods, body: BodyInit | undefined = undefined ): Promise<HttpOptions> => {

        let functionKey: string | null = state.functionKey;
    
        if( functionKey === null ) {

            functionKey = await getFunctionKey();

        }

        const authToken: string = await getIdToken( );

        const headers = new Headers( );
        const bearerToken = `Bearer ${authToken}`;
        headers.append( 'Authorization', bearerToken );
        headers.append( 'x-functions-key', functionKey! );
        headers.append( 'content-type', 'application/json' );

        const options: HttpOptions = {
            
            method,
            headers,
            body

        };

        return options;

    };

    const getHttpOptionsWithoutFunctionKey = ( authToken: string, method: HttpMethods, body: BodyInit | undefined = undefined ): HttpOptions => {

        const headers = new Headers( );
        const bearerToken = `Bearer ${authToken}`;
        headers.append( 'Authorization', bearerToken );
        headers.append( 'content-type', 'application/json' );

        const options: HttpOptions = {
            
            method,
            headers,
            body

        };

        return options;

    };
        
        
    return { 
        
        fetchData,
        getHttpOptions

    };

};



// export const fetchData = async ( options: HttpOptions, query: string  ): Promise<HttpResponse> => {

//     try {

//         const response: Response = await fetch( query, options );

//         if ( response.status === 200 ) {

//             return {

//                 response,
//                 statusCode: response.status

//             };


//         } else {

//             return {
        
//                 response: null,
//                 statusCode: response.status
        
//             };

//         }

//     } catch {

//         return {
        
//             response: null,
//             statusCode: null
    
//         };

//     }

// };


// export const getHttpOptions = async( authToken: string, functionKey: string | null, method: HttpMethods, body: BodyInit | undefined = undefined ): Promise<HttpOptions> => {

    
//     if( functionKey === null ) {

//         functionKey = await fetchFunctionKey();

//     }



//     const headers = new Headers( );
//     const bearerToken = `Bearer ${authToken}`;
//     headers.append( 'Authorization', bearerToken );
//     headers.append( 'x-functions-key', functionKey! );
//     headers.append( 'content-type', 'application/json' );

//     const options: HttpOptions = {
        
//         method,
//         headers,
//         body

//     };

//     return options;

// };


// const fetchFunctionKey = async (): Promise<string | null> => {

//     const { getFunctionKey } = useVspPortalHttp( );
//     const functionKey = await getFunctionKey();
//     return functionKey;

// };


// import { useContext } from "react";
// import { useAuth } from "../auth/useAuth";
// import { HttpMethods } from "../enums/HttpMethods";
// import { NotificationTypes } from "../enums/NotificationTypes";
// import { VspPortalActions } from "../store/VspPortalActions";
// import VspPortalContext from "../store/VspPortalContext";
// import { fetchData } from "../utils/useHttpUtil";
// import { HttpOptions } from "../data/HttpOptions";

// export const useVspPortalHttp = ( ): {

//     getFunctionKey( ): Promise< string | null >

// } => {

//     const { state, dispatch } = useContext( VspPortalContext );
//     const { getIdToken } = useAuth( );

//     const getFunctionKey = async( ): Promise< string | null > => {


//         
//         const options = await getHttpOptions ( HttpMethods.Get );
//         const query = `${process.env.REACT_APP_API_URL}/functionKey`;

//         const response = await fetchData( options, query  );
        
//         if ( response.response === null ) {

//             dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
//             dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching security info' });

//             return null;

//         }

//         const functionKey: string = await response.response?.text( );
//         dispatch({ type: VspPortalActions.SetFunctionKey, payload: functionKey  });
//         return functionKey;

//     };

//     const getHttpOptions = ( authToken: string, method: HttpMethods, body: BodyInit | undefined = undefined ): HttpOptions => {

//         const headers = new Headers( );
//         const bearerToken = `Bearer ${authToken}`;
//         headers.append( 'Authorization', bearerToken );
//         headers.append( 'content-type', 'application/json' );

//         const options: HttpOptions = {
            
//             method,
//             headers,
//             body

//         };

//         return options;

//     };

//     return { 
        
//         getFunctionKey,

//     };

// };